import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgGroceriesOutline24 = function SvgGroceriesOutline24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m22.833 4.909-1.242 6.301H7.4l-1.87-6.3h17.304zm-.85 10.149v-.97H8.255l-.568-1.908h14.687L24 3.94H5.257v.056L4.664 2H0v.97h3.955l3.592 12.087h14.435zm-2.156 5.973c-.924 0-1.677-.767-1.677-1.712 0-.943.753-1.71 1.677-1.71.925 0 1.677.767 1.677 1.71 0 .945-.752 1.712-1.677 1.712zm0-4.392c-1.452 0-2.633 1.202-2.633 2.68 0 1.48 1.181 2.682 2.633 2.682 1.453 0 2.633-1.202 2.633-2.682 0-1.478-1.18-2.68-2.633-2.68zM9.792 21.03c-.924 0-1.678-.767-1.678-1.712 0-.943.754-1.71 1.678-1.71.925 0 1.677.767 1.677 1.71 0 .945-.752 1.712-1.677 1.712zm0-4.392c-1.452 0-2.633 1.202-2.633 2.68 0 1.48 1.18 2.682 2.633 2.682s2.633-1.202 2.633-2.682c0-1.478-1.18-2.68-2.633-2.68z",
    fill: "currentColor"
  })));
};

var GroceriesOutline24Svg = SvgGroceriesOutline24;

export { GroceriesOutline24Svg as default };
//# sourceMappingURL=GroceriesOutline24.svg.js.map
